export default __webpack_public_path__ + "static/media/img_baseBunnyCrochet_lemon_p.028aa1d5.jpg";